<script>
import { mapGetters } from 'vuex';
import { useAccount } from 'dashboard/composables/useAccount';
import Banner from 'dashboard/components/ui/Banner.vue';

export default {
  components: { Banner },
  setup() {
    const { accountId } = useAccount();
    return { accountId };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
    }),
    shouldShowBanner() {
      const account = this.getAccount(this.accountId) || {};
      return !!account.show_grace_banner;
    },
    bannerMessage() {
      return this.$t('APP_GLOBAL.GRACE_PERIOD_NOTICE');
    },
  },
};
</script>

<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="warning"
    :banner-message="bannerMessage"
  />
</template>
